import { useTheme } from "@mui/material/styles";
export var MainLayoutStyles = function () {
    var theme = useTheme();
    return {
        wrapper: {
            display: "flex",
            backgroundColor: theme.palette.grey[100],
            ".MuiButton-outlinedPrimary": {
                borderColor: theme.palette.success.main,
            },
            ".MuiButton-outlinedWarning": {
                borderColor: theme.palette.warning.main,
            },
        },
        content: {
            appBar: {
                backgroundColor: theme.palette.grey[100],
            },
            toolbar: {
                p: 2,
            },
            container: {
                px: { xs: 0 },
            },
        },
    };
};
